'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CTA_COLOR_BY_NAME = exports.CTA_COLOR_BY_NAME = {
  danger: 'bt bt--danger bt--outline',
  danger_opaque: 'bt bt--danger bt--outline',
  danger_solid: 'bt bt--danger',
  default_opaque: 'bt bt--tertiary bt--outline',
  default: 'bt',
  marketing_black: 'bt bt--mkt-black bt--outline',
  marketing_black_opaque: 'bt bt--mkt-black bt--outline',
  marketing_black_solid: 'bt bt--mkt-black',
  marketing_white: 'bt bt--mkt-white bt--outline',
  marketing_white_solid: 'bt bt--mkt-white',
  primary: 'bt bt--primary bt--outline',
  primary_opaque: 'bt bt--primary bt--outline',
  primary_solid: 'bt bt--primary',
  tertiary: 'bt bt--tertiary'
};